import React, { useState } from 'react';

interface JoinCodeDisplayProps {
  code: string;
  connectedCount?: number;
  compact?: boolean;
}

export function JoinCodeDisplay({ code, connectedCount, compact }: JoinCodeDisplayProps) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  };

  if (compact) {
    return (
      <button
        type="button"
        onClick={() => void copy()}
        className="sala-glass group flex items-center gap-3 px-4 py-2 transition hover:border-[var(--sala-accent-neon)]"
      >
        <span className="sala-label">Código</span>
        <span className="font-display text-xl font-bold tracking-[0.2em] text-[var(--sala-accent-neon)]">
          {code}
        </span>
        <span className="text-[10px] text-[var(--sala-ink-dim)]">{copied ? '✓' : 'copiar'}</span>
      </button>
    );
  }

  return (
    <div className="sala-glass-raised relative overflow-hidden p-0">
      <div
        className="absolute inset-x-0 top-0 h-1"
        style={{ background: `linear-gradient(90deg, transparent, var(--sala-accent-neon), transparent)` }}
      />

      <div className="grid md:grid-cols-[1fr_auto]">
        <div className="border-b border-[var(--sala-border)] p-6 md:border-b-0 md:border-r">
          <p className="sala-label">Invita a tu clase</p>
          <p className="mt-4 sala-code-glyph">{code}</p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-[var(--sala-ink-muted)]">
            Los estudiantes abren <strong className="text-[var(--sala-accent-neon)]">/join</strong> en su
            móvil e ingresan este código.
          </p>
        </div>

        <div className="flex flex-col justify-center gap-3 p-6">
          {typeof connectedCount === 'number' && (
            <div className="text-center">
              <p className="font-display text-4xl font-bold text-[var(--sala-accent-neon)]">
                {connectedCount}
              </p>
              <p className="sala-label mt-1">conectados</p>
            </div>
          )}
          <button type="button" className="sala-btn-outline text-xs" onClick={() => void copy()}>
            {copied ? '¡Copiado al portapapeles!' : 'Copiar código'}
          </button>
          <a
            href={`/projector/${code}`}
            target="_blank"
            rel="noreferrer"
            className="sala-btn-hero text-center text-xs"
          >
            Abrir proyector ↗
          </a>
        </div>
      </div>
    </div>
  );
}
